import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Routes, Route, BrowserRouter, Navigate, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GalleryPage from "./Pages/Gallery/Gallery.page";
import HomePage from "./Pages/Home/Home.page";
import ContactPage from "./Pages/Contact/Contact.page";
import AboutPage from "./Pages/About/About.page";
import NavBar from "./Components/organisms/NavBar/NavBar";
import Footer from "./Components/organisms/Footer/Footer";
import CategoriesPage from "./Pages/Categories/Categories.page";
import { Box } from "@mui/system";
import RobomissionPage from "./Pages/Categories/Details/Robomission.page";
import ResearchersPage from "./Pages/Categories/Details/Researchers.page";
import FollowlinePage from "./Pages/Categories/Details/Followline.page";
import SumoPage from "./Pages/Categories/Details/Sumo.page";
import ScientificPage from "./Pages/Categories/Details/Scientific.page";
import Count from "./Components/molecules/Count/Count";
import FirstStagePage from "./Pages/Registration/FirstStage/FirstStage.page";
import FirstStageConfirmPage from "./Pages/Registration/FirstStageConfirm/FirstStageConfirm.page";
import CheckApplicationPage from "./Pages/Registration/CheckApplication/CheckApplication.page";
import LastStagePage from "./Pages/Registration/LastStage/LastStage.page";
import PaymentResultPage from "./Pages/PaymentResult/PaymentResult.page";
import PrivacyPage from "./Pages/Privacy/Privacy.page";
import TermsPage from "./Pages/Terms/Terms.page";
import RefundPage from "./Pages/Refund/Refund.page";
import TrainersAccPage from "./Pages/TrainersAcc/TrainersAcc.page";
import OrganizationAccPage from "./Pages/OrganizationAcc/OrganizationAcc.page";
import RobomissionKidsPage from "./Pages/Categories/Details/RobomissionKids.page";
import VirtualRobotPage from "./Pages/Categories/Details/Virtualrobot.page";
import ServicesPage from "./Pages/Services/Services.page";
import HistoryPage from "./Pages/History/History.page";
import GamePage from "./Pages/Game/Game.page";
import SportsEsportsRoundedIcon from "@mui/icons-material/SportsEsportsRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IconButton, Typography, Button } from "@mui/material";
import { useState } from "react";
import ChatBot from "./Components/organisms/Chatbot/Chatbot";

const GameAdvert = () => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        right: 20,
        top: 100,
        zIndex: 9999,
        width: {
          xs: "calc(100vw - 130px)",
          sm: "320px",
        },
        borderRadius: "20px",
        overflow: "hidden",
        background: "#fff",
        boxShadow: "0 20px 60px rgba(0,0,0,.18)",
        border: "1px solid rgba(0,0,0,.08)",
      }}
    >
      <IconButton
        size="small"
        onClick={() => setOpen(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          background: "rgba(255,255,255,.8)",
          zIndex: 2,
        }}
      >
        <CloseRoundedIcon fontSize="small" />
      </IconButton>

      <Box
        sx={{
          background:
            "linear-gradient(135deg,#23aef4 0%,#c11a83 100%)",
          p: 2,
          color: "#fff",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 700,
            textTransform: "uppercase",
            opacity: 0.9,
          }}
        >
          New Game 🚀
        </Typography>

        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 900,
            lineHeight: 1,
            mt: 0.5,
          }}
        >
          ZIKO RUN
        </Typography>
      </Box>

      <Box sx={{ p: 2 }}>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#555",
            mb: 2,
          }}
        >
          Run, jump, dodge obstacles and beat your friends'
          high scores. Play now for free!
        </Typography>

        <Button
          fullWidth
          variant="contained"
          startIcon={<SportsEsportsRoundedIcon />}
          onClick={() => { navigate("/game"); setOpen(false) }}
          sx={{
            borderRadius: "12px",
            py: 1.2,
            textTransform: "none",
            fontWeight: 700,
            background:
              "linear-gradient(90deg,#23aef4 0%,#c11a83 100%)",
          }}
        >
          Play Now
        </Button>
      </Box>
    </Box>
  );
};


const theme = createTheme({
  palette: {
    primary: {
      light: "#c11a83",
      main: "#c11a83",
      darker: "#595c61",
      tarnsparnt: "tarnsparnt",
      // contrastText: "#010102",
    },
    secondary: {
      light: "#23aef4",
      main: "#fff",
      dark: "#a4a4a3",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <NavBar />
        {/* <BucketList /> */}
        <Box sx={{ width: "100%", flex: "1" }}>
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/gallery" element={<GalleryPage />} />
            <Route exact path="/services" element={<ServicesPage />} />
            <Route exact path="/history" element={<HistoryPage />} />
            <Route exact path="/game" element={<GamePage />} />
            <Route exact path="/contact" element={<ContactPage />} />
            <Route exact path="/about" element={<AboutPage />} />
            <Route exact path="/payment" element={<PaymentResultPage />} />
            <Route exact path="/privacy" element={<PrivacyPage />} />
            <Route exact path="/terms" element={<TermsPage />} />
            <Route exact path="/refund" element={<RefundPage />} />
            <Route
              exact
              path="/accreditation/trainers"
              element={<TrainersAccPage />}
            />
            <Route
              exact
              path="/accreditation/organizations"
              element={<OrganizationAccPage />}
            />
            <Route exact path="/firststage" element={<FirstStagePage />} />
            <Route
              exact
              path="/firststage/registered"
              element={<FirstStageConfirmPage />}
            />
            {/* <Route path="/laststage" element={<LastStagePage />} />
            <Route path="/laststage/:code" element={<LastStagePage />} />
            <Route path="/check" element={<CheckApplicationPage />} />
            <Route path="/check/:code" element={<CheckApplicationPage />} /> */}
            <Route path="/categories" element={<CategoriesPage />} />
            <Route
              path="/competition/Robomission"
              element={<RobomissionPage />}
            />
            <Route
              path="/competition/RobomissionKids"
              element={<RobomissionKidsPage />}
            />
            <Route
              path="/competition/Followline"
              element={<FollowlinePage />}
            />
            <Route path="/competition/roboGuard" element={<SumoPage />} />
            <Route
              path="/competition/Researchers"
              element={<ResearchersPage />}
            />
            <Route
              path="/competition/Scientific"
              element={<ScientificPage />}
            />
            <Route
              path="/competition/VirtualRobot"
              element={<VirtualRobotPage />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Box>
        <ToastContainer />
        <Footer />

        <GameAdvert />
        <ChatBot />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
